import { Link } from 'react-router-dom';

function Footer({bg = true}) {
    return (
        <footer style={{ backgroundImage: bg !== "false" ? 'url(' + process.env.PUBLIC_URL + '/images/footer-bg.png)' : '' }}>
            {bg !== "false" && <div className="overlay"></div>}
            <div className="footer-container">
                <img className="logo-white" alt="iWantTFC" src={process.env.PUBLIC_URL + "/images/iwanttfc-white.svg" } />
                <div className="footer-links">
                    <Link to={process.env.REACT_APP_URL_HELP} target="_blank">Help and Support</Link>
                    <Link to={process.env.REACT_APP_URL_TERMS_AND_CONDITIONS} target="_blank">Terms and Conditions</Link>
                    <Link to={process.env.REACT_APP_URL_PRIVACY_POLICY} target="_blank">Privacy Policy</Link>
                    <Link to={process.env.REACT_APP_URL_COOKIE_POLICY} target="_blank">Cookie Policy</Link>
                    <Link to={process.env.REACT_APP_URL_ADVERTISE} target="_blank">Advertise With Us</Link>
                </div>
                <div className="social-links">
                    <Link to={process.env.REACT_APP_URL_FACEBOOK} rel="nofollow" target="_blank"><img alt="Facebook" src={process.env.PUBLIC_URL + "/images/socials/Facebook.svg" } /></Link>
                    <Link to={process.env.REACT_APP_URL_INSTAGRAM} rel="nofollow" target="_blank"><img alt="Instagram" src={process.env.PUBLIC_URL + "/images/socials/Instagram.svg" } /></Link>
                    <Link to={process.env.REACT_APP_URL_TIKTOK} rel="nofollow" target="_blank"><img alt="TikTok" src={process.env.PUBLIC_URL + "/images/socials/TikTok.svg" } /></Link>
                    <Link to={process.env.REACT_APP_URL_TWITTER} rel="nofollow" target="_blank"><img alt="X" src={process.env.PUBLIC_URL + "/images/socials/pajamas_twitter.svg" } /></Link>
                    <Link to={process.env.REACT_APP_URL_YOUTUBE} rel="nofollow" target="_blank"><img alt="YouTube" src={process.env.PUBLIC_URL + "/images/socials/Youtube.svg" } /></Link>
                </div>
                <p className="copyright">Copyright &copy; {new Date().getFullYear()}, iWantTFC | All Rights Reserved</p>
            </div>

        </footer>
    );
}

export default Footer;